import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
// store
import { currentUser } from 'store/reducers/currentUser'
// constants
import { USER_ROLES } from 'constants/users'
import { PUBLIC_PERMISSIONS } from 'constants/security'
// context
import { PublicContext } from 'containers/Risks/Risk/Edit/public'
// types
import { IUser, UserRoles } from 'types/graphql'
// utils
import momentTZ from 'moment-timezone'
import defaultTo from 'lodash/fp/defaultTo'

export const useCurrentUser = (): IUser & { timezone: string, isAdmin: boolean, isAuthorized: boolean } => {
  const isPublic = React.useContext(PublicContext)

  const user = useSelector(currentUser)

  const isAdmin = user?.roles?.includes(USER_ROLES.SKEFTO_ADMIN as UserRoles)
  const defaultTimezone = defaultTo(momentTZ.tz.guess(), user?.timezone)

  return {
    ...user,
    isAdmin,
    timezone: defaultTimezone,
    ...(isPublic && {
      permissionsFromSecurityGroups: PUBLIC_PERMISSIONS,
    }),
  }
}
